import { getGroupRatingApi } from "./get-group-rating"

import type { RemoveRankPermissionRequest, RemoveRankPermissionResponse } from "./types"

export const deleteGroupRatingApi = getGroupRatingApi.injectEndpoints({
  endpoints: builder => ({
    removeRankPermission: builder.mutation<RemoveRankPermissionResponse, RemoveRankPermissionRequest>({
      query: ({ chatId, rankId, permission }) => ({
        url: `/api/v1/group/rating/rank/permission?chat_id=${chatId}`,
        method: "DELETE",
        body: { rank_id: rankId, permission }
      }),
      invalidatesTags: (_result, error) => (error ? [] : ["PermissionUpdate"])
    })
  })
})

export const { useRemoveRankPermissionMutation } = deleteGroupRatingApi
